<template>
  <v-dialog v-model="dialog" width="700">
    <template v-if="Boolean(physician)" v-slot:activator="{ on, attrs }">
      <v-tooltip bottom v-bind="attrs" v-on="on">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-btn v-on="on" @click="dialog = true" x-small text
              ><v-icon small>mdi-pencil</v-icon></v-btn
            >
          </span>
        </template>
        <span> Edit Physician </span>
      </v-tooltip>
    </template>
    <template v-else v-slot:activator="{ on }">
      <v-btn v-on="on" @click="dialog = true" small tile outlined class="ma-2"
        >New Physician</v-btn
      ></template
    >
    <validation-observer ref="form" v-slot="{ invalid }">
      <v-card>
        <v-card-title color="primary">
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn color="primary" icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> </v-card-title
        ><v-card-text>
          <v-row>
            <v-col cols="12" sm="3">
              <validation-provider rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="form.displayName"
                  label="Display Name"
                  :error-messages="errors"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="form.firstName"
                  label="First Name"
                  :error-messages="errors"
                ></v-text-field
              ></validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="form.lastName"
                  label="Last Name"
                  :error-messages="errors"
                ></v-text-field
              ></validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="form.npi"
                  label="NPI"
                  :error-messages="errors"
                ></v-text-field
              ></validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" small text>Cancel</v-btn>
          <v-btn
            @click="save"
            :disabled="loading || invalid"
            small
            color="primary"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import Physician from "../../../objs/Physician";
export default {
  props: ["physician"],
  data() {
    return {
      form: new Physician(),
      dialog: false,
      loading: false,
    };
  },
  mounted() {
    if (this.physician) {
      this.form = { ...this.physician };
    }
  },
  computed: {
    title() {
      return Boolean(this.physician) ? "Edit Physician" : "New Physician";
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.form = new Physician();
    },
    async save() {
      this.loading = true;
      var message;
      // update
      if (this.physician) {
        message = await this.$store.dispatch(
          "optionsModule/updatePhysician",
          this.form
        );
      }
      // create
      else {
        message = await this.$store.dispatch(
          "optionsModule/createPhysician",
          this.form
        );
      }
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Physician saved successfully."
        );
      }
      this.$store.commit("uxModule/setShowSnackbar", true);
      this.closeDialog();
      this.loading = false;
    },
  },
};
</script>